export default "__VITE_ASSET__SocKXe9k__";